// In-code, we allowlist lenses we support on the Camera Kit SDK reflecting:
// https://camera-kit.snapchat.com/organizations/4f9b3b41-0d25-43ce-aedf-548644fd61a4/groups
// So we know when to render the "Try lens" button, or otherwise.
export const LENS_ALLOWLIST = [
    // test lenses
    "49414230875",
    "44949520876",
    // prod lenses
    "60402770881",
    "57224890880",
    "35737890980",
    "57281480877",
    "45672280910",
    "5189866427682816",
    "59625371061",
    "58517751140",
    "57228280934",
    "58918780925",
    "60297360931",
    "58700230889",
    "58271330876",
    "49254620875",
    "57138250905",
    "47931700975",
    "58944190875",
    "58270661040",
    "43675310939",
    "56211010875",
    "56426980885",
    "56709140882",
    "56567650879",
    "43203181154",
    "57931600888",
    "59000820884",
    "59237300885",
    "60066840875",
    "38808740951",
    "41872400912",
    "60535481056",
    "60535610905",
    "60394490913",
    "60265820887",
    "58614400879",
    "59224430903",
    "58221890882",
    "59165810876",
    "57980640876",
    "58256780895",
    "43731041040",
    "35674231032",
    "52290080885",
    "50193280875",
    "55122790876",
    "53570880904",
    "58206260889",
    "57841340882",
    "57963440988",
    "58260150892",
    "42875130947",
    "57727110889",
    "4824945048641536",
    "59417990913",
    "57321481074",
    "59403640883",
    "42417581158",
    "59752180963",
    "42007490964",
    "42469070876",
    "59388910875",
    "57240830876",
    "57359440901",
    "45342050907",
    "58833120926",
    "56337600876",
    "43598601322",
    "26077897265",
    "56380840888",
    "57716950937",
    "56520540877",
    "58064100895",
    "58300720902",
    "58829440885",
    "60038170885",
    "40928430930",
    "57685370875",
    "56202360889",
    "59520270889",
    "56594640877",
    "58360980887",
    "57064880880",
    "58961710883",
    "37530330970",
    "57341850877",
    "58559750888",
    "58953580901", // https://www.snapchat.com/lens/bd883c3f410e44bb9e4b83ebb7e9aa4a
];
export const DESKTOP_LENS_ALLOWLIST = [
    ...LENS_ALLOWLIST,
    // test lenses
    "50507980875",
    "43276930875",
    "43281170875",
    "43293650876", // CamKit Hair Color https://www.snapchat.com/lens/2c9a9945b19645f498b8c36ee965951f
];
export const MOBILE_LENS_ALLOWLIST = [...LENS_ALLOWLIST];
export const DESKTOP_GROUP_ID = "5823ca90-5e1a-44b4-a007-644cab5c6e64";
export const MOBILE_GROUP_ID = "9dd58917-be52-4075-8487-0af3978494da";
